import  React, { useState, Suspense } from "react";
import "../navbar.css";
import {LinkContainer} from 'react-router-bootstrap';
import Image from 'react-bootstrap/Image';
import Nav from 'react-bootstrap/Nav';
import NavbarMobile from "./mobileOffcanvas";
import imageList from '../imageList.json';


function Navigationbar() {
  const [active, setActive] = useState("nav__menu");
  const [icon, setIcon] = useState("nav__toggler");
  const navToggle = () => {
    if (active === "nav__menu") {
      setActive("nav__menu nav__active");
    } else setActive("nav__menu");

    // Icon Toggler
    if (icon === "nav__toggler") {
      setIcon("nav__toggler toggle");
    } else setIcon("nav__toggler");
  };
  return (
    <Nav fill variant="tabs"  defaultActiveKey="/home" >

      <LinkContainer to="/">
      <a className="nav__brand">
        {imageList.map((imagePath, index) => (
          (imagePath.indexOf('home') !== -1) && <Image src={`/images/${imagePath}`} alt={`Image ${index}`} roundedCircle/>
        ))}
      </a> 
      </LinkContainer>
    
        <Nav.Item  >
        <LinkContainer to="/fondant" className="nav__link">
            <Nav.Link className="nav__link">Fondant Cakes</Nav.Link> 
          </LinkContainer>
        </Nav.Item>
        <Nav.Item  >
        <LinkContainer to="/icing">
          <Nav.Link className="nav__link">Icing Cakes</Nav.Link> 
          </LinkContainer>
        </Nav.Item>
        <Nav.Item>
        <LinkContainer to="/dessert">
              <Nav.Link className="nav__link">Dessert Table</Nav.Link> 
            </LinkContainer>
        </Nav.Item>
        <Nav.Item>
        <LinkContainer to="/prices">
              <Nav.Link className="nav__link">Prices</Nav.Link> 
            </LinkContainer>
        </Nav.Item>
      
       <NavbarMobile/>
    </Nav>
   
  );
}

export default Navigationbar;